import { gql } from '@apollo/client';

export const SEARCH_QUERY = gql`
  query search($query: String!, $limit: Int) {
    search(query: $query, limit: $limit) {
      posts {
        PK
        SK
        title
        subtitle
        category
        username
        displayName
        createdAt
        readTime
      }
      authors {
        PK
        SK
        username
        displayName
        bio
      }
      replies {
        PK
        SK
        parentPostId
        rootPostId
        title
        username
        createdAt
        depth
      }
      totalPosts
      totalAuthors
      totalReplies
    }
  }
`;
